<template>
  <div class="error-container">
    <i class="fa fa-times-circle fa-5x" style="color: #d16c00"></i>
    <h5 style="font-weight: bold; color: #d16c00">Uh oh...</h5>
    <p>
      Your request could not be completed. Please
      <a style="cursor: pointer" @click="reload">click here</a> to refresh the
      page.
    </p>
  </div>
</template>

<script>
export default {
  methods: {
    reload() {
      window.location.reload();
    },
  },
};
</script>

<style scoped>
.error-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #eeeeee;
  height: 200px;
  width: 100%;
}
</style>
